import { useFormik } from "formik";
import React, { useState } from "react";
import {
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import EmailConfigService from "../../../services/KangarooServices/EmailConfigService";
import toast from "react-hot-toast";
import Select from "react-select";

const EmailRecipientForm = ({ isOpen, toggle, selectedItem, fetchData }) => {
  console.log("🚀 ~ EmailRecipientForm ~ selectedItem:", selectedItem);
  const [loading, setLoading] = useState(false);
  const formik = useFormik({
    initialValues: {
      id: selectedItem?.id,
      email: selectedItem?.email || "",
      name: selectedItem?.name || "",
      isActive: selectedItem?.isActive || true,
      formPages: selectedItem?.formPages
        ? selectedItem.formPages.map((page) => page.id)
        : [],
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        if (selectedItem?.id) {
          await EmailConfigService.updateRecipient(selectedItem?.id, values);
          toast.success("Recipient updated successfull.");
        } else {
          await EmailConfigService.createRecipient(values);
          toast.success("New recipient added successfull.");
        }
        fetchData();
        toggle();
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    },
  });
  const formPages = [
    {
      label: "Banner",
      value: 1,
    },
    {
      label: "Homepage",
      value: 2,
    },
    {
      label: "Service General Form",
      value: 3,
    },
    {
      label: "Service Detail Form",
      value: 4,
    },
    {
      label: "Newsletter",
      value: 5,
    },
    {
      label: "Consultation Form",
      value: 6,
    },
    {
      label: "Contact",
      value: 7,
    },
    {
      label: "Institution",
      value: 8,
    },
    {
      label: "Career",
      value: 9,
    },
    {
      label: "Become a franchise",
      value: 10,
    },
  ];
  const formPagesOptions = formPages?.map((i) => ({
    value: i.value,
    label: i.label,
  }));
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Email Recipient</ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          <FormGroup>
            <Label>Email Address</Label>
            <Input
              type="email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.email && !!formik.errors.email}
            />
            <FormFeedback>{formik.errors.email}</FormFeedback>
          </FormGroup>

          <FormGroup>
            <Label>Recipient Name</Label>
            <Input
              type="text"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.name && !!formik.errors.name}
            />
            <FormFeedback>{formik.errors.name}</FormFeedback>
          </FormGroup>

          <FormGroup className="mb-3">
            <Label>Form Pages</Label>
            <Select
              name="formPages"
              isMulti
              options={formPagesOptions}
              value={formPagesOptions.filter((option) =>
                formik.values.formPages.includes(option.value),
              )}
              onChange={(selectedOptions) =>
                formik.setFieldValue(
                  "formPages",
                  selectedOptions ? selectedOptions.map((o) => o.value) : [],
                )
              }
              isClearable
            />
          </FormGroup>
          <FormGroup className="d-flex justify-content-between">
            <Label>Is Active?</Label>
            <Input
              type="checkbox"
              checked={formik.values.isActive}
              onChange={(e) =>
                formik.setFieldValue("isActive", e.target.checked)
              }
            />
          </FormGroup>
          <div className="d-flex justify-content-end gap-3 ">
            <button
              type="submit"
              className="btn btn-success"
              disabled={loading}
            >
              {selectedItem?.id ? "Update" : "Create"}
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={toggle}
              disabled={loading}
            >
              Cancel
            </button>
          </div>
        </form>
      </ModalBody>
      <ModalFooter></ModalFooter>
    </Modal>
  );
};

export default EmailRecipientForm;
